// language selector
window.addEventListener('DOMContentLoaded', async function () {
    const url = window.location.href.split('/');
    let country = '';
    for (let i = 0; i < url.length; i++) {
        if (url[i] == 'fr' || url[i] == 'en-gb' || url[i] == 'en-eu') {
            country = url[i];
            break;
        }
    }
    if (country == 'fr') {
        document.querySelector('.language-selector-button span').innerHTML = 'France';
        document.querySelector('.language-selector-list li[data-country="FR"]').classList.add('active');
        document.querySelector('.footer__seo-href span[data-country="FR"]').classList.add('active');
    } else if (country == 'en-gb') {
        document.querySelector('.language-selector-button span').innerHTML = 'UK';
        document.querySelector('.language-selector-list li[data-country="GB"]').classList.add('active');
        document.querySelector('.footer__seo-href span[data-country="GB"]').classList.add('active');
    } else if (country == 'en-eu') {
        document.querySelector('.language-selector-button span').innerHTML = 'Global';
        document.querySelector('.language-selector-list li[data-country="International"]').classList.add('active');
        document.querySelector('.footer__seo-href span[data-country="International"]').classList.add('active');
    } else {
        await fetch(
            window.Shopify.routes.root
            + 'browsing_context_suggestions.json'
            + '?country[enabled]=true'
            + `&country[exclude]=${window.Shopify.country}`
            + '&language[enabled]=true'
            + `&language[exclude]=${window.Shopify.language}`
        ).then(r => r.json())
            .then(function(r) {
                if (r.detected_values.country.handle == 'US' || Shopify.country == 'US') {
                    document.querySelector('.language-selector-button span').innerHTML = 'US';
                    document.querySelector('.language-selector-list li[data-country="US"]').classList.add('active');
                    document.head.insertAdjacentHTML("beforeend", `<style>.recommendation-modal__backdrop, .recommendation-modal__container {display:none;}</style>`)
                    if (Shopify.currency.active != "USD") {
                        updateLocalization({country: "US", language: 'en'});
                    }
                } else {
                    document.querySelector('.language-selector-button span').innerHTML = 'US';
                    document.querySelector('.language-selector-list li[data-country="US"]').classList.add('active');
                }
            })
    }
})

function updateLocalization({country, language}) {
    const formId = crypto.randomUUID();
    let actualPath = window.location.pathname;
    const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
        <input name="_method" value="PUT">
        <input name="country_code" value="${country}">
        <input name="language_code" value="${language}">
        <input type="hidden" name="return_to" value="${actualPath}">
      </form>
    `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
}

window.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.language-selector-button').addEventListener('click', function () {
        this.classList.toggle('active');
        document.querySelector('.language-selector-list').classList.toggle('active');
    })

    var customOptions = document.querySelectorAll('.language-selector-list li');
    for (let i = 0; i < customOptions.length; i++) {
        customOptions[i].addEventListener('click', async function () {
            document.querySelector('.language-selector-button').classList.remove('active');
            document.querySelector('.language-selector-list').classList.remove('active');
            document.querySelector('.language-selector-button span').innerHTML = this.innerHTML;

            var selectedCountry = this.getAttribute('data-country');
            if (selectedCountry == 'FR') {
                updateLocalization({country: selectedCountry, language: 'fr'});
            } else if (selectedCountry == 'GB') {
                updateLocalization({country: selectedCountry, language: 'en'});
            } else if (selectedCountry == 'US') {
                updateLocalization({country: selectedCountry, language: 'en'});
            } else {
                var pathname = window.location.pathname.replace('/en-gb', '').replace('/fr', '');
                window.location.href = '/en-eu' + pathname;
            }
        })
    }

    var customOptionFooter = document.querySelectorAll('.footer__seo-href span');
    for (let i = 0; i < customOptionFooter.length; i++) {
        customOptionFooter[i].addEventListener('click', async function () {
            var selectedCountry = this.getAttribute('data-country');
            if (selectedCountry == 'FR') {
                updateLocalization({country: selectedCountry, language: 'fr'});
            } else if (selectedCountry == 'GB') {
                updateLocalization({country: selectedCountry, language: 'en'});
            } else if (selectedCountry == 'US') {
                updateLocalization({country: selectedCountry, language: 'en'});
            } else {
                var pathname = window.location.pathname.replace('/en-gb', '').replace('/fr', '');
                window.location.href = '/en-eu' + pathname;
            }
        })
    }
})